import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-14 mt-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-8">
          {/* Logo & Company */}
          <div>
            <img src="/sudeporte-logo.png" alt="Sudeporte" className="h-10 mb-4" />
            <p className="text-neutral-400 text-sm max-w-xs">
              Plataforma B2B de Sudeporte para clubes MACRON. Circuito exclusivo
              de la temporada 26/27.
            </p>
          </div>

          {/* Pedidos Sudeporte */}
          <div>
            <h3 className="text-lg font-bold mb-4">Sudeporte · Macron</h3>
            <div className="text-neutral-300 text-sm space-y-2">
              <p className="font-semibold text-white">Pedidos y facturación</p>
              <p>
                <a href="mailto:pedidos@sudeporte.com" className="text-white hover:underline">
                  pedidos@sudeporte.com
                </a>
              </p>
              <p>
                <a href="mailto:laura@sudeporte.com" className="text-white hover:underline">
                  laura@sudeporte.com
                </a>
              </p>
              <p>
                <a href="mailto:macron@sudeporte.com" className="text-white hover:underline">
                  macron@sudeporte.com
                </a>
              </p>
            </div>
          </div>

          {/* Cliente Autorizado */}
          <div>
            <h3 className="text-lg font-bold mb-4">Cliente autorizado</h3>
            <div className="text-neutral-300 text-sm space-y-2">
              <p className="font-semibold text-white">Deportes Tomás Elda</p>
              <p>
                <a href="mailto:deportestomasinfo@gmail.com" className="text-white hover:underline">
                  deportestomasinfo@gmail.com
                </a>
              </p>
              <p className="pt-2 text-neutral-400">
                Compras oficiales del club Elda Unión CF · Temporada 26/27
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-neutral-800 pt-6 text-center">
          <p className="text-neutral-500 text-sm">
            © {new Date().getFullYear()} SUDEPORTE · SUDEPORTE — Todos los derechos reservados. MACRON® es marca registrada de sus respectivos titulares.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
